<template>
  <div class="ccui-app-container">
    <el-group-title :title="title">
      <template slot="groupTitle">
        <el-form
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
          label-position="right"
        >
          <el-row>
            <el-col :span="12">
              <!--设备 左树右表-->
              <el-form-item label="物装目录(多选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="dialogtreetableTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <dialogtreetable @handleTrue="handleTrue"></dialogtreetable>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--    选择物装目录 左树右表-->
              <el-form-item label="物装目录(单选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="dialogtreetableRadioTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <dialogtreetableRadio
                      @handleTrue="handleTrueTreeTable"
                    ></dialogtreetableRadio>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--物装目录-->
              <el-form-item label="物装目录(单选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="matCaterySingleLeftTreeRightTableTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <matCaterySingleLeftTreeRightTable
                      @handleTrue="matCaterySingleLeftTreeRightTableConfirm"
                    ></matCaterySingleLeftTreeRightTable>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--    选择物装目录-->
              <el-form-item label="物装目录(多选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="matCateryMultiLeftTreeRightTableTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <matCateryMultiLeftTreeRightTable
                      @handleTrue="matCateryMultiLeftTreeRightTableConfirm"
                    >
                    </matCateryMultiLeftTreeRightTable>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
    <el-group-title :title="title2">
      <template slot="groupTitle">
        <el-form
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
          label-position="right"
        >
          <el-row>
            <el-col :span="12">
              <!--    选择管理员-->
              <el-form-item label="人员(多选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="staffSelectorTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <selectTree
                      @selectedStaffSuccess="selectedStaffSuccess"
                      mode="checkbox"
                    >
                    </selectTree>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--    选择管理员单选-->
              <el-form-item label="人员(单选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="selectedStaffSuccessRadioTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <selectTree
                      @selectedStaffSuccess="selectedStaffSuccessRadio"
                    >
                    </selectTree>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--    选择团体关系-->
              <el-form-item label="团体关系(单选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="partyRelationSingleSelectTreeTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <partyRelationSingleSelectTree
                      @selectedStaffSuccess="
                        partyRelationSingleSelectTreeConfirm
                      "
                    >
                    </partyRelationSingleSelectTree>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--    选择团体关系-->
              <el-form-item label="团体关系(多选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="partyRelationMultiSelectTreeTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <partyRelationMultiSelectTree
                      @selectedStaffSuccess="
                        partyRelationMultiSelectTreeConfirm
                      "
                      mode="checkbox"
                    >
                    </partyRelationMultiSelectTree>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
    <el-group-title :title="title3">
      <template slot="groupTitle">
        <el-form
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
          label-position="right"
        >
          <el-row>
            <el-col :span="12">
              <!--用户-->
              <el-form-item label="用户(多选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="demoUserTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <demo_user
                      @inventoryConfirm="demoUserInventoryConfirm"
                    ></demo_user>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!--    选择人员目录-->
              <el-form-item label="用户(单选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="codeNumberTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <codeNumber
                      @inventoryConfirm="codeNumberInventoryConfirm"
                    ></codeNumber>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item label="用户(多选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="demoUserMultiSelectTableTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <demoUserMultiSelectTable
                      @inventoryConfirm="
                        demoUserMultiSelectTableInventoryConfirm
                      "
                    ></demoUserMultiSelectTable>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item label="用户(单选生成)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="demoUserSingleSelectTableTextarea"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <demoUserSingleSelectTable
                      @inventoryConfirm="
                        demoUserSingleSelectTableInventoryConfirm
                      "
                    ></demoUserSingleSelectTable>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
    <el-group-title :title="title4">
      <template slot="groupTitle">
        <el-form
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
          label-position="right"
        >
          <el-row>
            <el-col :span="12">
              <!--用户-->
              <el-form-item
                class="ccui-pre-form"
                label="租户本级及所有分支成员用户(多选)："
              >
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="advancedUserSelectorTextarea"
                      placeholder="在租户组织所有分支范围内选择成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <advancedUserSelector
                      @inventoryConfirm="
                        advancedUserSelectorselectedUserSuccess
                      "
                    >
                    </advancedUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item
                class="ccui-pre-form"
                label="租户本级及所有分支成员用户(单选)："
              >
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="advancedUserSelectorTextarearadio"
                      placeholder="在租户组织所有分支范围内选择成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <advancedUserSelector
                      mode="radio"
                      @inventoryConfirm="
                        advancedUserSelectorselectedUserSuccessradio
                      "
                    >
                    </advancedUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item label="本级成员(多选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="selfUnitUserSelectorTextarea"
                      placeholder="在分支本级范围内选择成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <selfUnitUserSelector
                      @inventoryConfirm="
                        selfUnitUserSelectorselectedUserSuccess
                      "
                    >
                    </selfUnitUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item label="本级成员(单选)：">
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="selfUnitUserSelectorTextarearadio"
                      placeholder="在分支本级范围内选择成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <selfUnitUserSelector
                      mode="radio"
                      @inventoryConfirm="
                        selfUnitUserSelectorselectedUserSuccessradio
                      "
                    >
                    </selfUnitUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item
                class="ccui-pre-form"
                label="分支本级及下级成员(多选)："
              >
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="subLevelUserSelectorTextarearadio"
                      placeholder="在分支本级及下级范围内选成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <subLevelUserSelector
                      @inventoryConfirm="subLevelUserSelectorUserSuccessradio"
                    >
                    </subLevelUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--用户-->
              <el-form-item
                class="ccui-pre-form"
                label="分支本级及下级成员(单选)："
              >
                <el-row :gutter="20">
                  <el-col :span="17">
                    <el-input
                      type="textarea"
                      v-model="subLevelUserSelectorTextarea"
                      placeholder="在分支本级及下级范围内选成员"
                      disabled
                    ></el-input>
                  </el-col>
                  <el-col :span="6">
                    <subLevelUserSelector
                      mode="radio"
                      @inventoryConfirm="subLevelUserSelectorUserSuccess"
                    >
                    </subLevelUserSelector>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import demo_user from "./components/demo_user";
import dialogtreetableRadio from "./components/dialogtreetableRadio";
import selectTree from "./components/staffSelector";
import codeNumber from "./components/codeNumber";
import dialogtreetable from "./components/dialogtreetable";
import matCaterySingleLeftTreeRightTable from "./components/matCaterySingleLeftTreeRightTable";
import demoUserMultiSelectTable from "./components/demoUserMultiSelectTable";
import demoUserSingleSelectTable from "./components/demoUserSingleSelectTable";
import partyRelationSingleSelectTree from "./components/partyRelationSingleSelectTree";
import partyRelationMultiSelectTree from "./components/partyRelationMultiSelectTree";
import matCateryMultiLeftTreeRightTable from "./components/matCateryMultiLeftTreeRightTable";
import advancedUserSelector from "./components/advancedUserSelector";
import selfUnitUserSelector from "./components/selfUnitUserSelector";
import subLevelUserSelector from "./components/subLevelUserSelector";
export default {
  abbrName: "reference",
  components: {
    subLevelUserSelector,
    selfUnitUserSelector,
    advancedUserSelector,
    matCateryMultiLeftTreeRightTable,
    partyRelationMultiSelectTree,
    partyRelationSingleSelectTree,
    demoUserSingleSelectTable,
    demoUserMultiSelectTable,
    matCaterySingleLeftTreeRightTable,
    demo_user,
    dialogtreetable,
    dialogtreetableRadio,
    selectTree,
    codeNumber
  },
  data() {
    return {
      selectedData: [],
      mode: "checkbox",
      title: "左树右表",
      title2: "树",
      title3: "单表",
      title4: "成员选择",
      isShow: false,
      isShow2: false,
      subLevelUserSelectorTextarearadio: "",
      subLevelUserSelectorTextarea: "",
      advancedUserSelectorTextarea: "",
      advancedUserSelectorTextarearadio: "",
      selfUnitUserSelectorTextarearadio: "",
      selfUnitUserSelectorTextarea: "",
      materialsTextarea: "",
      inventoryTextarea: "",
      demoUserTextarea: "",
      dialogtreetableTextarea: "",
      selectedStaffSuccessRadioTextarea: "",
      dialogtreetableRadioTextarea: "",
      codeNumberTextarea: "",
      matCaterySingleLeftTreeRightTableTextarea: "",
      demoUserMultiSelectTableTextarea: "",
      demoUserSingleSelectTableTextarea: "",
      partyRelationSingleSelectTreeTextarea: "",
      partyRelationMultiSelectTreeTextarea: "",
      matCateryMultiLeftTreeRightTableTextarea: "",
      staffSelectorTextarea: ""
    };
  },
  methods: {
    advancedUserSelectorselectedUserSuccess(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.advancedUserSelectorTextarea = date.join("，");
    },
    subLevelUserSelectorUserSuccessradio(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.subLevelUserSelectorTextarearadio = date.join("，");
    },
    subLevelUserSelectorUserSuccess(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.subLevelUserSelectorTextarea = date.join("，");
    },
    advancedUserSelectorselectedUserSuccessradio(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.advancedUserSelectorTextarearadio = date.join("，");
    },
    selfUnitUserSelectorselectedUserSuccess(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.selfUnitUserSelectorTextarea = date.join("，");
    },
    selfUnitUserSelectorselectedUserSuccessradio(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.selfUnitUserSelectorTextarearadio = date.join("，");
    },
    selectedStaffSuccess(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.staffSelectorTextarea = date.join("，");
    },
    selectedStaffSuccessRadio(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.selectedStaffSuccessRadioTextarea = date.join("，");
    },
    handleTrueTreeTable(data) {
      this.dialogtreetableRadioTextarea = data.categoryName;
    },
    codeNumberInventoryConfirm(data) {
      this.codeNumberTextarea = data.userName;
    },
    dialogTreeTableTrue(data) {
      let date = [];
      data.map(item => {
        date.push(item.matName);
      });
      this.materialsTextarea = date.join("，");
    },
    inventoryinventoryTextarea(data) {
      let date = [];
      data.map(item => {
        date.push(item.abbrName);
      });
      this.inventoryTextarea = date.join("，");
    },
    demoUserInventoryConfirm(data) {
      let date = [];
      data.map(item => {
        date.push(item.userName);
      });
      this.demoUserTextarea = date.join("，");
    },
    matCaterySingleLeftTreeRightTableConfirm(data) {
      this.matCaterySingleLeftTreeRightTableTextarea = data.categoryName;
    },
    demoUserMultiSelectTableInventoryConfirm(data) {
      let date = [];
      data.map(item => {
        date.push(item.userName);
      });
      this.demoUserMultiSelectTableTextarea = date.join("，");
    },
    demoUserSingleSelectTableInventoryConfirm(data) {
      this.demoUserSingleSelectTableTextarea = data.userName;
    },
    partyRelationSingleSelectTreeConfirm(data) {
      let date = [];
      data.map(item => {
        date.push(item.name);
      });
      this.partyRelationSingleSelectTreeTextarea = date.join("，");
    },
    partyRelationMultiSelectTreeConfirm(data) {
      let date = [];
      data.map(item => {
        date.push(item.name);
      });
      this.partyRelationMultiSelectTreeTextarea = date.join("，");
    },
    matCateryMultiLeftTreeRightTableConfirm(data) {
      let date = [];
      data.map(item => {
        date.push(item.categoryName);
      });
      this.matCateryMultiLeftTreeRightTableTextarea = date.join("，");
    },
    handleTrue(data) {
      let date = [];
      data.map(item => {
        date.push(item.matName);
      });
      this.dialogtreetableTextarea = date.join("，");
    }
  }
};
</script>

<style scoped lang="scss">
.el-form {
  /deep/ .el-textarea__inner {
    padding: 5px 23px !important;
  }

  /deep/ .el-col-12 {
    height: 70px;
  }
  /deep/ .dialog-footer {
    line-height: 20px !important;
    display: block;
  }
}
/deep/ .el-group-title .ccui-form .el-row .el-form-item {
  margin-bottom: 20px !important;
}
/deep/ .ccui-pre-form {
  .el-form-item__label {
    padding-right: 10px !important;
  }
}
</style>
